<template>
  <div
    class="effect-setting setting-popup"
    v-if='boxData.judgeBox'
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      滤镜
    </div>

    <div class="settting-popup__content">
      <ul class="items">
        <li class="item" v-for="(item, i) in items" :key="i">
          <div class="item__title">{{item.text}}</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :number-unit="''"
              :step="item.step"
              :numFixed="item.fixed"
              :minVal="item.min"
              :maxVal="item.max"
              :msg="{type: item.type}"
              @updateValue="onFilterSliderUpdated"
              ref="filterSlider"
            ></slider>
          </div>
        </li>
      </ul>
    </div>

    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>


<script>
import popup from '../../mixins/popup.vue'
import slider from '../../popups/content/slider.vue'
import map from 'lodash/map';
import toAnalysisParams from '@/plugins/toAnalysisParams'

export default {
  mixins: [popup],
  components: {
    slider
  },
  data () {
    return {
      popupType: 'filterSetting',
      items: [
        {type: 'blur', text: '模糊', step: 1, min: 0, max: 100},
        {type: 'brightness', text: '亮度', step: 1, min: 0, max: 10},
        {type: 'contrast', text: '对比度', step: 1, min: 0, max: 10},
        {type: 'saturate', text: '饱和度', step: 1, min: 0, max: 10},
        {type: 'grayscale', text: '灰度', step: 0.1, min: 0, max: 1, fixed: 1},
        {type: 'hueRotate', text: '色相', step: 10, min: 0, max: 360},
        {type: 'invert', text: '反色', step: 0.1, min: 0, max: 1, fixed: 1},
        {type: 'sepia', text: '加温', step: 0.1, min: 0, max: 1, fixed: 1},
      ],
      reports: {
        blur: 'filter_setting,drag_blur,滤镜设置_模糊',
        brightness: 'filter_setting,drag_brightness,滤镜设置_亮度',
        contrast: 'filter_setting,drag_cotrast,滤镜设置_对比度',
        saturate: 'filter_setting,drag_saturation,滤镜设置_饱和度',
        grayscale: 'filter_setting,drag_grey,滤镜设置_灰度',
        hueRotate: 'filter_setting,drag_warm,滤镜设置_加温',
        invert: 'filter_setting,drag_hue,滤镜设置_色相',
        sepia: 'filter_setting,drag_invert,滤镜设置_反色',
      },
      bgReports: {
        blur: 'filter_setting,drag_blur_bg,滤镜设置_模糊_背景',
        brightness: 'filter_setting,drag_brightness_bg,滤镜设置_亮度_背景',
        contrast: 'filter_setting,drag_cotrast_bg,滤镜设置_对比度_背景',
        saturate: 'filter_setting,drag_saturation_bg,滤镜设置_饱和度_背景',
        grayscale: 'filter_setting,drag_grey_bg,滤镜设置_灰度_背景',
        hueRotate: 'filter_setting,drag_warm_bg,滤镜设置_加温_背景',
        invert: 'filter_setting,drag_hue_bg,滤镜设置_色相_背景',
        sepia: 'filter_setting,drag_invert_bg,滤镜设置_反色_背景',
      }
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.render();
          });
        }
      }
    }
  },
  methods: {
    isBg () {
      return this.boxData.data.sprite && this.boxData.data.sprite.type === 'bg';
    },
    render () {
      let spriteFilter = this.isBg()
        ? this.SelectScenes_Msg.getBackgroundFilter()
        : this.sprite.filter;

      let sliders = this.$refs.filterSlider;
      map(spriteFilter, (v, k) => {
        let currSlider = (sliders.filter(slider => {
          return slider.msg && slider.msg.type === k
        }) || [])[0];
        currSlider && currSlider.updateValFromOutside(v)
      })
    },
    onFilterSliderUpdated (val, undo, msg) {
      if (this.isBg()) {
        this.setBg(val, undo, msg);
      } else {
        this.setSprite(val, undo, msg)
      }
    },
    setSprite (val, undo, msg) {
      this.sprite.setFilter({[msg.type]: val}, undo);
      if (undo) {
        this.$analysis(toAnalysisParams(this.reports[msg.type]))
      }
    },
    setBg (val, undo, msg) {
      this.SelectScenes_Msg.setBackgroundFilter({[msg.type]: val}, undo || false, undo);
      if (undo) {
        this.$analysis(toAnalysisParams(this.bgReports[msg.type]))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  min-height: 180px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.items {
  padding-top: 25px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 14px;
  padding-right: 14px;
  margin-bottom: 25px;

  &__title {
    flex-shrink: 0;
    width: 56px;
    margin-right: 10px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/filterSetting/filterSetting.vue